module.exports = __webpack_public_path__ + "static/media/icomoon.f2de1a9c.svg";